import { HttpErrorResponse } from '@angular/common/http';
import { MonoTypeOperatorFunction, Observable, catchError, map, throwError } from 'rxjs';
import { ApiResponse, FieldError } from './api.types';

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly fieldErrors: FieldError[] = [],
  ) {
    super(message);
  }
}

export function unwrap<T>() {
  return (source: Observable<ApiResponse<T>>): Observable<T> =>
    source.pipe(
      map((res) => res.data as T),
      toApiError<T>(),
    );
}

export function toApiError<T>(): MonoTypeOperatorFunction<T> {
  return catchError((err: unknown) => throwError(() => normalizeError(err)));
}

export function normalizeError(err: unknown): ApiError {
  if (err instanceof ApiError) return err;
  if (err instanceof HttpErrorResponse) {
    const body = err.error as
      | { statusMessage?: string; message?: string; data?: unknown }
      | null;
    const fieldErrors = Array.isArray(body?.data) ? (body.data as FieldError[]) : [];
    const message =
      body?.statusMessage ??
      body?.message ??
      (err.status === 0 ? 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้' : err.message);
    return new ApiError(message, err.status, fieldErrors);
  }
  return new ApiError(err instanceof Error ? err.message : 'Unknown error', 0);
}
